
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"6.5","cy":"6.5","r":"6","fill":"#7A48AC","fill-opacity":".15","stroke":"#7A48AC"}}),_c('svg',{attrs:{"width":"9","height":"13","viewBox":"-2 0 9 7","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M3.61 6.071L.643 3.006l.83-.827L3.594 4.34l3.9-4.054.863.811L3.61 6.071z","fill":"#7A48AC"}})])])
          )
        }
      }
    